import { filter, map, of, take, type Observable } from 'rxjs';
import {
    activityIdentitiesEqual,
    type ActivityIdentity,
} from '../activity-journal';
import type { ActivityToastDecisionSnapshot } from './action-contract';

export type ActivityBuildingResolutionState = readonly [
    settledBuildingPublicIds: ReadonlySet<string>,
    identity: ActivityIdentity | null,
    activeIdentityVersion: number,
];

export function waitForActivityBuildingResolution(
    decision: ActivityToastDecisionSnapshot,
    resolution$: Observable<ActivityBuildingResolutionState>
): Observable<ActivityToastDecisionSnapshot> {
    const buildingPublicId = decision.buildingPublicId;
    if (!buildingPublicId) return of(decision);

    return resolution$.pipe(
        filter(
            ([settledBuildingPublicIds, identity, identityVersion]) =>
                activityIdentitiesEqual(identity, decision.identity) &&
                identityVersion === decision.activeIdentityVersion &&
                settledBuildingPublicIds.has(buildingPublicId)
        ),
        take(1),
        map(() => decision)
    );
}
